import { VideoPlaylist } from '@/components/VideoPlaylist';
import { LabradorComponent } from '@/types/component';

export const LabradorVideoPlaylist: LabradorComponent = ({ data }) => {
  return <VideoPlaylist title={data.title} playlistId={data.playlistId} />;
};
